'use strict'
const name = 'BgZoomIn'
const properties = {
    hideOnStart: false,
    requestFullScreenHeight: true,
    getMaxTravel(elementMeasure, viewportHeight) {
        return viewportHeight + elementMeasure.height
    },
    groups: ['animation', 'background'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0
        },
        perspectiveParent: {
            type: 'element'
        },
        parallaxParent: {
            type: 'element'
        },
        speedFactor: {
            type: 'number',
            default: 0.8
        }
    }
}

function register({factory}) {
    /**
     * @param {HTMLElement[]} elements DOM elements to animate
     * @param {Number} [duration]
     * @param {Number} [delay]
     * @param {Object} [params] Timeline optional parameters.
     * @returns {TimelineMax}
     */
    function animation(elements, duration, delay, {
        parallaxParent,
        speedFactor = properties.schema.speedFactor.default,
        ...params
    } = {}) {
        const sequence = factory.sequence(params)

        // tombigel, July 2020 TODO:
        // As long as we use fixed bgMedia element inside the animation we cant use balata as the perspective parent
        // We have to use the old element.children method here, and assume it is ok to animate all the media children
        // This animation should be simplified when (if) changing to the root to fixed and removing fixed from the media bg

        sequence.add([
            ...elements.map(element => factory.animate('BaseBgParallaxY', element.children, duration, delay, {
                parallaxParent,
                speedFactor,
                start: 0,
                end: 1,
                ease: 'none'
            })),
            ...elements.map(element => factory.animate('BaseBgZoom', element.children, duration, delay, {
                perspectiveParent: element,
                speedFactor: 0,
                in: {
                    start: 0,
                    end: 1,
                    scale: 1.667,
                    ease: 'sine.in'
                }
            }))
        ])

        return sequence.get()
    }

    factory.registerAnimation(name, animation, properties)
}

module.exports = {
    name,
    properties,
    register
}
